import React, { useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { useOnClickOutside } from "../../utils/hooks/useOnClickOutside";
import { Checkbox, Tabs } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Icon from "../Icon";
import { UiPickListDropdown, UiCheckList, UiClearButton, SingleList } from "./PickListDropdown.style";
/**
 * 客製化下拉選單(多選)
 */

const PickListDropdown = ({
  defaultTitle = "標題",
  value = [],
  options = [],
  onChange = () => {}
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [title, setTitle] = useState("");
  const dropdownRef = useRef();

  const intersection = (target, compare) => {
    const arrSet = new Set(compare);
    let isFirst = true;
    return target.map(item => {
      if (arrSet.has(item.value)) {
        const newItem = { ...item,
          checked: true
        };
        return newItem;
      }

      return item;
    });
  };

  const initOptions = data => {
    if (data.length === 0 || !data) return [];
    const nextData = data.map(item => {
      let checked = false;
      return { ...item,
        checked
      };
    });
    return intersection(nextData, value);
  };

  const newData = useMemo(() => {
    return initOptions(options);
  }, [value, options]);
  useOnClickOutside(dropdownRef, () => setDropdownOpen(false));

  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const checkboxChangeHandler = (e, list) => {
    const tmpOptions = [...newData];
    const isChecked = e.target.checked;
    const existItemIndex = tmpOptions.findIndex(item => item.value === list.value);
    tmpOptions[existItemIndex].checked = isChecked;
    const tmp = tmpOptions.filter(option => option.checked);

    if (tmpOptions.filter(option => option.checked === true).length === 1) {
      setTitle(tmp[0].name);
    }

    const checkedGroup = tmpOptions.filter(item => item.checked === true);
    onChange(checkedGroup.map(item => item.value));
  };

  const formateTitle = () => {
    const checkedOptions = newData.filter(item => item.checked === true);

    if (checkedOptions.length === 1) {
      return title || checkedOptions[0].name;
    } else if (checkedOptions.length > 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, title || checkedOptions[0].name), /*#__PURE__*/React.createElement("span", {
        className: "others"
      }, checkedOptions.length - 1));
    }
  };

  const clearHandler = () => {
    const tmpData = [...newData];
    tmpData.map(item => {
      item.checked = false;
      return item;
    });
    onChange([]);
  };

  return /*#__PURE__*/React.createElement(UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, value.length > 0 ? formateTitle() : defaultTitle), /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "optionsWrap"
  }, options && newData.map((item, index) => {
    return /*#__PURE__*/React.createElement(UiCheckList, {
      key: index
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onChange: e => checkboxChangeHandler(e, item),
      checked: item.checked
    }, item.name));
  })), /*#__PURE__*/React.createElement("div", {
    className: "action"
  }, /*#__PURE__*/React.createElement(UiClearButton, {
    disabled: value.length > 0 ? false : true,
    onClick: clearHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(CloseOutlined, null)), "\u6E05\u9664"))));
};

export default PickListDropdown;
/**
 * 客製化下拉選單(單選)
 */

export const SinglePickListDropdown = ({
  defaultTitle = "defaultTitle",
  value,
  displayType = "value",
  clearable = false,
  options = [],
  onClick = () => {},
  onPickListClear = () => {}
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isHover, setHover] = useState(false);
  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, () => setDropdownOpen(false));

  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const checkboxCheckHandler = checkList => {
    onClick(checkList.value, checkList.name);
    dropdownOpenHandler();
  };

  const onClear = event => {
    event.stopPropagation();
    onPickListClear();
  };

  return /*#__PURE__*/React.createElement(UiPickListDropdown, {
    ref: dropdownRef,
    onMouseEnter: () => {
      setHover(true);
    },
    onMouseLeave: () => {
      setHover(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, displayType === "value" ? value ? value : defaultTitle : value && options.length > 0 ? options.filter(item => item.value === value)[0]?.name : defaultTitle), /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, isHover && clearable ? /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    color: "#fff",
    onClick: event => onClear(event)
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "optionsWrap"
  }, options && options.map((item, index) => {
    return /*#__PURE__*/React.createElement(UiCheckList, {
      key: index
    }, /*#__PURE__*/React.createElement(SingleList, {
      onClick: () => checkboxCheckHandler(item)
    }, item.name));
  }))));
};
/**
 * tab切換多選下拉選單
 */

export const TabPickListDropdown = ({
  defaultTitle = "題型",
  checkedList = {},
  options = [],
  onChange = () => {},
  onCheckAll = () => {}
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, () => setDropdownOpen(false));

  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const checkAll = (checked, val) => {
    const nextData = checked ? val.subMap.map(item => item.value) : [];
    onCheckAll(nextData, [val.value]);
  };

  const calAllCheckedCount = useMemo(() => {
    let count = 0;
    if (Object.keys(checkedList).length === 0) return count;
    Object.entries(checkedList).forEach(([, value]) => {
      value.forEach(() => {
        count++;
      });
    });
    return count;
  }, [Object.keys(checkedList).length]);
  return /*#__PURE__*/React.createElement(UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, defaultTitle, calAllCheckedCount ? /*#__PURE__*/React.createElement("span", {
    className: "others"
  }, calAllCheckedCount) : ""), /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "optionsWrap tabs"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "1"
  }, options && options.map((item, index) => {
    return /*#__PURE__*/React.createElement(Tabs.TabPane, {
      tab: /*#__PURE__*/React.createElement("div", {
        className: "tabHeader"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: checkedList[item.value] && checkedList[item.value].length === item.subMap.length,
        onChange: e => {
          checkAll(e.target.checked, item);
        }
      }), item.name, checkedList[item.value] ? /*#__PURE__*/React.createElement("span", {
        className: "tabCheckCount"
      }, checkedList[item.value].length) : ""),
      key: item.value
    }, /*#__PURE__*/React.createElement(Checkbox.Group, {
      value: checkedList[item.value] || [],
      options: item.subMap.map(optionItem => ({
        label: optionItem.name,
        value: optionItem.value
      })),
      onChange: val => {
        onChange && onChange(val, item.value);
      }
    }));
  })))));
};
PickListDropdown.propTypes = {
  defaultTitle: PropTypes.string,
  value: PropTypes.array,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  })),
  onChange: PropTypes.func
};
SinglePickListDropdown.propTypes = {
  defaultTitle: PropTypes.string,
  value: PropTypes.any,
  clearable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  })),
  onClick: PropTypes.func,
  onPickListClear: PropTypes.func,
  displayType: PropTypes.string
};
TabPickListDropdown.propTypes = {
  defaultTitle: PropTypes.string,
  checkedList: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  })),
  onChange: PropTypes.func,
  onCheckAll: PropTypes.func
};